import { __assign, __rest } from "tslib";
import React from 'react';
import { useComponentRegistry } from '@bem-react/di';
import { cnMenu } from '../Menu';
export var MenuGroup = function (_a) {
    var children = _a.children, className = _a.className, title = _a.title, props = __rest(_a, ["children", "className", "title"]);
    var Title = useComponentRegistry(cnMenu()).Title;
    return (React.createElement("div", __assign({}, props, { role: "group", className: cnMenu('Group', null, [className]) }),
        title && React.createElement(Title, null, title),
        children));
};
